import { Area, AreaChart, CartesianGrid, Line, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { ChartTooltip } from "./ChartTooltip";

const M = { top: 8, right: 4, left: 0, bottom: 0 };
const AX = { stroke: "hsl(var(--muted-foreground))", fontSize: 12, tickLine: false, axisLine: false };
const CURSOR = { stroke: "hsl(var(--primary) / 0.35)", strokeWidth: 1, strokeDasharray: "3 3" };

// منحنى منطقة عالي الاحتراف: تدرّجات ثلاثية النقاط + توهج + نقاط تفاعلية بحلقة بيضاء.
export const ChartArea = ({ data }) => (
  <ResponsiveContainer width="100%" height="100%">
    <AreaChart data={data} margin={M}>
      <defs>
        <linearGradient id="presentFill" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%"   stopColor="#10b981" stopOpacity={0.55} />
          <stop offset="55%"  stopColor="#10b981" stopOpacity={0.18} />
          <stop offset="100%" stopColor="#10b981" stopOpacity={0.02} />
        </linearGradient>
        <linearGradient id="absentFill" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%"   stopColor="#f43f5e" stopOpacity={0.35} />
          <stop offset="100%" stopColor="#f43f5e" stopOpacity={0.02} />
        </linearGradient>
        <filter id="lineGlow" x="-20%" y="-40%" width="140%" height="180%">
          <feGaussianBlur stdDeviation="2.5" result="g" />
          <feMerge><feMergeNode in="g" /><feMergeNode in="SourceGraphic" /></feMerge>
        </filter>
      </defs>
      <CartesianGrid strokeDasharray="4 6" stroke="hsl(var(--border))" vertical={false} />
      <XAxis dataKey="label" {...AX} />
      <YAxis width={28} allowDecimals={false} {...AX} />
      <Tooltip content={<ChartTooltip />} cursor={CURSOR} />
      <Area type="monotone" dataKey="present" stroke="#10b981" strokeWidth={3} strokeLinecap="round"
            fill="url(#presentFill)" filter="url(#lineGlow)" animationDuration={800}
            activeDot={{ r: 7, fill: "#10b981", stroke: "#fff", strokeWidth: 2 }} />
      <Area type="monotone" dataKey="absent" stroke="#f43f5e" strokeWidth={2.5} strokeLinecap="round"
            fill="url(#absentFill)" animationDuration={800}
            activeDot={{ r: 6, fill: "#f43f5e", stroke: "#fff", strokeWidth: 2 }} />
      <Line type="monotone" dataKey="late" stroke="#f59e0b" strokeWidth={2.5} strokeLinecap="round"
            strokeDasharray="5 4" dot={false} animationDuration={800}
            activeDot={{ r: 5, fill: "#f59e0b", stroke: "#fff", strokeWidth: 2 }} />
    </AreaChart>
  </ResponsiveContainer>
);
